/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Search_Results_PlaceholderInputs */



/**
* | output |
* | --- |
* | "Search results will appear here." |
*
* @param {Explorer_Search_Results_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_search_results_placeholder = /** @type {((inputs?: Explorer_Search_Results_PlaceholderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Search_Results_PlaceholderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Search results will appear here.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Search results will appear here.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Search results will appear here.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Search results will appear here.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Search results will appear here.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Search results will appear here.")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Search results will appear here.")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Search results will appear here.")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Search results will appear here.")
	return /** @type {LocalizedString} */ ("Search results will appear here.")
});